import { isAmhpAccreditation } from "./user.js";
// The practitioner identity portion of a form part's context, derived purely
// from the acting user, so a caller that only needs to (re)set the practitioner
// — e.g. an application redo adopting the initiating AMHP's details — can do so
// without a patient.
export function buildUserContext(user, isGuest, guestAccreditation) {
    return {
        id: user.id,
        email: user.email,
        name: isGuest ? "" : user.name,
        address: isGuest ? "" : user.address.address,
        postalCode: isGuest ? "" : user.address.postalCode,
        isConfirmed: !isGuest,
        isSection12Approved: !isGuest
            ? user.accreditations.some((a) => a.type === "section-12")
            : (guestAccreditation?.isSection12Approved ?? null),
        isApprovedClinician: !isGuest
            ? user.accreditations.some((a) => a.type === "approved-clinician")
            : null,
        isGuest,
        localAuthority: !isGuest
            ? (user.accreditations.find(isAmhpAccreditation)?.localAuthority ?? "")
            : "",
    };
}
export function buildDefaultContext(patient, user, isGuest, guestAccreditation) {
    return {
        user: buildUserContext(user, isGuest, guestAccreditation),
        patient: {
            name: `${patient.name.given} ${patient.name.family}`,
            address: patient.address.address,
            postalCode: patient.address.postalCode,
            dateOfBirth: patient.dateOfBirth || null,
        },
    };
}
//# sourceMappingURL=formPartContext.js.map